<template v-once>
  <img src="@/assets/icons/iqvia_icon.jpg" alt="iqvia icon">
</template>

<script>
export default {
  name: "Iqvia",
};
</script>

<style scoped>
</style>